import React from 'react'
import { useSelector} from 'react-redux' 
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { adminlog } from '../../../features/auth';

const Loginprotectedroute = ({children}) => {
    let dispatch = useDispatch()
       let token = localStorage.getItem('token')
       if(token){
          dispatch(adminlog(true))
       }
    const {adminlogedin } = useSelector((state)=>state.auth);
    
    if( adminlogedin){
       return <Navigate to='/home' />
    }else{
        return children
    }
 
}

export default Loginprotectedroute
